<template>
	<div class="product2">
		<div class="product2-c" v-for="(item, index) in list" :key="index">
			<div class="product2-info" v-if="index%2==0">
				<div class="l">
					<div class="t">{{item.productName}}</div>
					<div class="s">{{item.content1}}</div>
				</div>
				<img class="r" :src="item.profile" alt="">
			</div>
			<div class="product2-info" v-else>
				<img class="r" :src="item.profile" alt="">
				<div class="l">
					<div class="t">{{item.productName}}</div>
					<div class="s">{{item.content1}}</div>
				</div>
			</div>
		</div>
		<div class="pagebox">
			<el-pagination background layout="prev, pager, next" :total="total" @current-change	="currentchange	">
			</el-pagination>
		</div>
		
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			},
			total:{
				type:Number,
				default:0
			}
		},
		data() {
			return {

			}
		},
		created() {

		},
		methods: {
			currentchange(e) {
				console.log(e, "----------000----------")
				this.$emit("currentchange", e)
			}

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}
	.product2 {
		padding-bottom: 30px;

		.product2-c {
			background-color: white;
			display: flex;
			justify-content: center;
			margin-bottom: 20px;
			
			.product2-info {
				background-color: #F5F5F5;
				justify-content: space-between;
				.l {
					
					.t {
						color: #22A3D3;
					}
					.s {
						color: #333333;
					}
				}
				.r {
					object-fit: cover;
					transition: transform 0.3s;
				}
				.r:hover {
				       transition: width 0.3s, height 0.3s;
				       transform: scale(0.95);
				       
				      }
				
				
			}
		}
	
	    .pagebox {
	    	justify-content: center;
	    	display: flex;
	    	align-items: center;
	    
	    }
	
	}
	
	@media screen and (min-width: 1200px) {
		.product2 {
			width: 100%;
			.product2-c {
				width: 100%;
				padding-top: 80px;
				
				.product2-info {
					width: 1200px;
					height: 420px;
					display: flex;
					.l {
						width: calc(30% - 20px);
						height: 100%;
						padding: 40px;
						height: 420px;
						.t {
							font-size: 22px;
						}
						.s {
							margin-top: 20px;
							font-size: 18px;
						}
					}
					.r {
						width: 70%;
						height: 100%;
					}
				}
			}		
		}
	
	}
	@media screen and (max-width: 1200px) {
		.product2 {
			width: 100%;
			.product2-c {
				width: 100%;
				padding: 50px 20px 0;
				
				.product2-info {
					width: 100%;
					height: 360px;
					display: flex;
					.l {
						width: calc(30% - 20px);
						height: 100%;
						padding: 24px;
						height: 360px;
						.t {
							font-size: 18px;
						}
						.s {
							margin-top: 20px;
							font-size: 15px;
						}
					}
					.r {
						width: 70%;
						height: 100%;
					}
				}
			}		
		}
	
	}
	@media screen and (max-width: 880px) {
		.product2 {
			width: 100%;
			.product2-c {
				width: 100%;
				padding: 16px 12px 0;
				.product2-info {
					width: 100%;
					height: 200px;
					display: flex;
					.l {
						width: calc(40% - 20px);
						height: 100%;
						padding: 24px;
						height: 200px;
						.t {
							font-size: 15px;
						}
						.s {
							margin-top: 20px;
							font-size: 13px;
						}
					}
					.r {
						width: 60%;
						height: 100%;
					}
				}
			}		
		}
	
	}
</style>
